import { FormErrorLabel, FormInput, FormSelect, FormTextarea, Heading, Loader } from "@/components";
import useAddEdit from "./useAddEdit";
import { FormProvider } from "react-hook-form";
import { CHECKLIST_ITEM, DESCRIPTION, NAME, TITLE, IMPORTANCE_FLAG } from "./consts";
import { importanceFlagOptions } from "@/lib/utils";
import { Button } from "@/components/ui";
import { Trash2 } from "lucide-react";

const AddEdit = () => {
  const {
    onBackClick,
    form,
    onSubmit,
    requiredFields,
    isAddPending,
    onCancel,
    onAddMoreTask,
    onDeleteTask,
    isAddItemPending,
    isView,
    isDeleteItemPending,
    isUpdatePending,
    isLoadingChecklistData,
    isLoadingChecklistItems,
    title
  } = useAddEdit();
  const { errors } = form.formState;

  return (
    <div>
      <Heading
        title={title}
        showBack
        onBackClick={onBackClick}
      />

      {isLoadingChecklistData || isLoadingChecklistItems ? <Loader /> : 
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="bg-white mt-[20px] rounded-lg shadow-sm overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] px-[30px] py-[25px]">
              <div>
                <FormInput
                  name={TITLE}
                  control={form.control}
                  label="Checklist Title"
                  placeholder="Please enter"
                  error={errors[TITLE]?.message}
                  isRequired={requiredFields.includes(TITLE)}
                  disabled={isView}
                />
              </div>
              <FormTextarea
                name={DESCRIPTION}
                control={form.control}
                label="Description"
                placeholder="Please enter"
                error={errors[DESCRIPTION]?.message}
                isRequired={requiredFields.includes(DESCRIPTION)}
                disabled={isView}
              />
            </div>
            <div className="bg-brown-200 col-span-2 gap-[20px] px-[30px] py-[25px]">
              <div className="grid grid-cols-1 gap-[20px]">
                {form.watch(CHECKLIST_ITEM)?.map((_, index: any) => (
                   <div key={`quality-item-${index}`} className="flex flex-row items-end w-full gap-4">
                    <div className="flex-1">
                      <FormInput
                        name={`${CHECKLIST_ITEM}.${index}.${NAME}`}
                        control={form.control}
                        label="Checklist Item"
                        placeholder="Please enter"
                        error={
                          (errors as any)?.[CHECKLIST_ITEM]?.[index]?.[NAME]?.message ?? ''
                        }
                        isRequired={requiredFields.includes(
                          `${CHECKLIST_ITEM}.${index}.${NAME}`
                        )}
                        disabled={isView}
                      />
                    </div>
                    <div className="flex-1">
                      <FormSelect
                        name={`${CHECKLIST_ITEM}.${index}.${IMPORTANCE_FLAG}`}
                        control={form.control}
                        label="Priority Checklist"
                        placeholder="Please select"
                        options={importanceFlagOptions}
                        error={
                          (errors as any)?.[CHECKLIST_ITEM]?.[index]?.[IMPORTANCE_FLAG]?.message ?? ''
                        }
                        isRequired={requiredFields.includes(
                          `${CHECKLIST_ITEM}.${index}.${IMPORTANCE_FLAG}`
                        )}
                        disabled={isView}
                      />
                    </div>
                    <Trash2
                      className="stroke-red-600 w-6 h-6 cursor-pointer mb-3"
                      onClick={onDeleteTask(index)}
                    />
                  </div>
                ))}
              </div>
              <FormErrorLabel className="relative">{errors[CHECKLIST_ITEM]?.root?.message || ""}</FormErrorLabel>
              {isView ? <></> : <Button onClick={onAddMoreTask} type="button" variant="link">
                + Add More
              </Button>}
            </div>
          </div>
          <div className="flex flex-row justify-end gap-3 py-5">
            <Button
              variant="outline"
              type="button"
              onClick={onCancel}
              disabled={isAddPending || isAddItemPending || isUpdatePending || isDeleteItemPending}
            >
              Cancel
            </Button>
            {isView ? <></> : <Button type="submit" disabled={isAddPending || isAddItemPending || isUpdatePending || isDeleteItemPending}>
              {isAddPending || isUpdatePending || isDeleteItemPending ||
                isAddItemPending && <Loader variant="secondary" />}
              Save
            </Button>}
          </div>
        </form>
      </FormProvider>}
    </div>
  );
};

export default AddEdit;
